/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TrimesterObservationParam from './trimester-observation-param';
import TrimesterObservationParamDetail from './trimester-observation-param-detail';
import TrimesterObservationParamUpdate from './trimester-observation-param-update';
import TrimesterObservationParamDeleteDialog from './trimester-observation-param-delete-dialog';

const TrimesterObservationParamRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TrimesterObservationParam />} />
    <Route path="new" element={<TrimesterObservationParamUpdate />} />
    <Route path=":id">
      <Route index element={<TrimesterObservationParamDetail />} />
      <Route path="edit" element={<TrimesterObservationParamUpdate />} />
      <Route path="delete" element={<TrimesterObservationParamDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TrimesterObservationParamRoutes;
